import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import ItemMaster from "./ItemMaster";

class TripItemEntry extends Component {
  state = {
    formData: {
      srno: "",
      Item: "",
      Driver: "",
      Wt: "",
      Rate: "",
      Amount: "",
    },

    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Trip Entry";
    this.props.setActiveMenu("TripEntry");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle
  onAddClickItem = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ItemMaster />
          defaultOpenDialog={true}
          handleOnClickNo={this.getCustomerList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  //#endregion handle

  getInfo = () => {};

  onFormLoad = () => {};

  handleOnList = () => {};

  render() {
    return (
      <from>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Trip Item Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="srno"
              label="Sr. No.*"
              disabled={true}
              value={this.state.formData.srno}
              handleOnChange={this.handleOnChange}
              width={85}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          spacing={2}
          justifyContent="flex-start"
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="Item"
              label="Item Name*"
              items={[]}
              value={this.state.formData.Item}
              handleOnChange={this.handleOnChange}
              width={500}
              maxLength={100}
              bolVisibleOnAddClickIcon={
                this.props.userPrivilege.Customer == "A" ? true : false
              }
              onAddClick={this.onAddClickItem}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="Wt"
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          spacing={2}
          justifyContent="flex-start"
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="Wt"
              value={this.state.formData.Wt}
              handleOnChange={this.handleOnChange}
              label="Wt*"
              width={155}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="Rate"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="Rate"
              value={this.state.formData.Rate}
              handleOnChange={this.handleOnChange}
              label="Rate*"
              width={155}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="Remark"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="Amount"
              value={this.state.formData.Amount}
              handleOnChange={this.handleOnChange}
              label="Amount*"
              width={155}
              disabled={true}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtMultiLineText
              id="Remark"
              value={this.state.formData.Remark}
              handleOnChange={this.handleOnChange}
              label="Remark*"
              width={500}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtBtn label="Save" onClick={this.save} />
          </Grid>

          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} />
          </Grid>
          <Grid item>
            <CtBtn label="Remove" onClick={this.onDeleteBtnClick} />
          </Grid>
        </Grid>

        <br />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </from>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(TripItemEntry))));
